import VueObserveVisibility from 'vue-observe-visibility';

import VueCountdown from '@chenfengyuan/vue-countdown';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import AppUpselling from './vue/AppUpselling.vue'
import AppRating from './vue/AppRating.vue'
import AppRelease from './vue/AppRelease.vue'
import DealBanner from './vue/DealBanner.vue'
import CouponGiftModal from './vue/CouponGiftModal.vue'
import GiftManager from './vue/GiftManager.vue'

// Public-Path für dynamisch nachgeladene Chunks (z. B. video.js) robust bestimmen,
// abgeleitet aus dem Speicherort von main.js. Bewusst NICHT webpacks 'auto', da dieses
// in der Plenty-Umgebung eine Exception wirft und dadurch die Bundle-Ausführung abbricht.
try {
    var kuipersMainScript = document.querySelector('script[src*="/dist/main.js"]');
    if (kuipersMainScript) {
        __webpack_public_path__ = kuipersMainScript.src.replace(/main\.js.*$/, '');
    }
} catch (e) { /* Fallback: relativer Pfad */ }

Vue.component(VueCountdown.name, VueCountdown);

Vue.use(VueObserveVisibility);
Vue.component('app-upselling', AppUpselling)
Vue.component('app-rating', AppRating)
Vue.component('app-release', AppRelease)
Vue.component('deal-banner', DealBanner)
Vue.component('coupon-gift-modal', CouponGiftModal)
Vue.component('gift-manager', GiftManager)

// Slider-Initialisierung (Swiper-Header/Headlines + Flickity-Carousels).
// Idempotent: prüft el.swiper bzw. .flickity-enabled -> keine Doppel-Init.
// Hintergrund: Ceres mountet die Vue-App ASYNCHRON (nach dem Laden der ceres-*-
// Chunks) und rendert/ersetzt dabei #vue-app - und zwar NACH $(document).ready.
// Dadurch gehen die zuvor gesetzten Slider verloren. Deshalb wird bei jeder
// Änderung an #vue-app (MutationObserver unten) neu initialisiert.
function initKuipersSliders() {
    document.querySelectorAll('.swiper-header').forEach(function (el) {
        if (el.swiper) return; // bereits initialisiert
        new Swiper(el, {
            modules: [Autoplay],
            slidesPerView: 1,
            touchRatio: 0.2,
            autoplay: { delay: 3000 },
        });
    });

    document.querySelectorAll('.swiper-container-headlines').forEach(function (el) {
        if (el.swiper) return;
        new Swiper(el, {
            modules: [Autoplay],
            loop: true,
            spaceBetween: 0,
            centeredSlides: true,
            speed: 6000,
            autoplay: { delay: 1, pauseOnMouseEnter: true },
            slidesPerView: 'auto',
            allowTouchMove: true,
            disableOnInteraction: false,
        });
    });

    // Flickity wird global über theme.min.js bereitgestellt (window.Flickity) und
    // hat in diesem Build KEINE HTML-Auto-Init -> hier manuell. Optionen kommen aus
    // dem data-flickity-Attribut (u. a. watchCSS -> mobil an / ab Desktop aus).
    if (window.Flickity) {
        document.querySelectorAll('[data-flickity]').forEach(function (el) {
            if (el.classList.contains('flickity-enabled')) return;
            var options = {};
            try {
                options = JSON.parse(el.getAttribute('data-flickity')) || {};
            } catch (e) { /* ungültiges JSON -> Defaults */ }
            new window.Flickity(el, options);
        });
    }
}

// Nach jedem (Re-)Render von #vue-app durch Ceres die Slider neu setzen. subtree,
// damit es sowohl den Dev-Mode-Austausch (replaceChild) als auch das In-Place-
// Patching im Live-Mode abdeckt. Debounced + idempotent -> günstig.
(function () {
    var reinitTimer = null;
    var schedule = function () {
        clearTimeout(reinitTimer);
        reinitTimer = setTimeout(initKuipersSliders, 100);
    };
    var observer = new MutationObserver(schedule);
    var start = function () {
        observer.observe(document.body, { childList: true, subtree: true });
        // Fallback: ein paar gezielte Versuche, falls der Mount sehr spät kommt.
        [0, 500, 1500, 3000].forEach(function (ms) { setTimeout(initKuipersSliders, ms); });
    };
    if (document.body) {
        start();
    } else {
        document.addEventListener('DOMContentLoaded', start);
    }
})();

$(document).ready(function () {
    const links = document.querySelectorAll('.nav-link-tab');
    const contents = document.querySelectorAll('.content');

// Funktion zum Aktivieren des gewünschten Tabs
    function activateTab(targetId, scroll = true) {
        links.forEach(l => l.classList.toggle('active', l.dataset.target === targetId));
        contents.forEach(c => {
            const isActive = c.id === targetId;
            c.style.display = isActive ? 'block' : 'none';
            // Wenn aktiv und scroll gewünscht → smooth scroll
            if (isActive && scroll) {
                c.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }
// Klick-Event für Tabs
    links.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const target = link.dataset.target;
            activateTab(target);
            // Hash in URL aktualisieren
            history.replaceState(null, '', '#' + target);
        });
    });

// Reaktion auf Hash-Wechsel (auch bei Zurück/Vorwärts im Browser)
    window.addEventListener('hashchange', () => {
        const hash = window.location.hash.replace('#', '');
        if (hash) activateTab(hash);
    });


// Beim Laden prüfen, ob ein Hash vorhanden ist
    window.addEventListener('DOMContentLoaded', () => {
        const hash = window.location.hash.replace('#', '');
        if (hash) {
            activateTab(hash, false); // false = nicht sofort scrollen
            // danach sanft scrollen, falls gewünscht
            document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    var t = document.querySelectorAll("[data-countdown]");

    function n(t, e) {
        var a = t - (new Date).getTime(), o = Math.floor(a / 864e5);
        o = o < 10 ? "0" + o : o;
        var n = Math.floor(a % 864e5 / 36e5);
        n = n < 10 ? "0" + n : n;
        var l = Math.floor(a % 36e5 / 6e4);
        l = l < 10 ? "0" + l : l;
        var i = Math.floor(a % 6e4 / 1e3);
        i = i < 10 ? "0" + i : i, e.querySelector("[data-days]").innerHTML = o, e.querySelector("[data-hours]").innerHTML = n, e.querySelector("[data-minutes]").innerHTML = l, e.querySelector("[data-seconds]").innerHTML = i
    }

    t.length && [].forEach.call(t, function (t) {
        var e, a, o;
        a = (e = t).dataset.date, n(o = new Date(a).getTime(), e), setInterval(function () {
            n(o, e)
        }, 1e3)
    })

    initKuipersSliders();

    if ($('.product-info-section__hidden-text').length) {
        $('.product-info-section__text').html($('.product-info-section__hidden-text').html());
        $('.product-info-section').show();
    }

    function scrollToHash(delay = 3000) {
        setTimeout(() => {
            const hash = window.location.hash;

            if (!hash) return;

            const target = document.querySelector(hash);

            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }, delay);
    }

    scrollToHash();

    // Textarea-Floating-Label: Platzhalter setzen, damit :placeholder-shown greift
    document.querySelectorAll('.widget-contact-form .input-unit.textarea textarea:not([placeholder])')
        .forEach(el => el.setAttribute('placeholder', ' '));

    // Tooltips in Payment & Shipping deaktivieren
    $(document).on('show.bs.tooltip', '.payment-method-select *, .shipping-method-select *', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    });
});

Vue.component("av-countdown", {

    template: '#av-countdown',

    props: {
        date: String,
        inline: Boolean,
    },

    data() {
        return {
            milliseconds: 0,
            showCounter: true,
        }
    },

    created() {
        const t1 = new Date(this.date);
        const t2 = new Date();

        const dif = t1.getTime() - t2.getTime();

        if (dif < 0) {
            this.showCounter = false;
        }

        this.milliseconds = Math.abs(dif);
    }
});

Vue.component("kuipers-video-player", {

    template: '#kuipers-video-player',

    props: {
        videos: {
            type: [Array, String],
            required: true,
        },
        maxHeight: {
            type: Number,
            default: 30000,
        },
        poster: String,
        muted: {
            type: Boolean,
            default: false,
        },
        autoplay: {
            type: Boolean,
            default: false,
        },
        loop: {
            type: Boolean,
            default: false,
        },
        controls: {
            type: Boolean,
            default: true,
        },
        showSlotOnPlay: {
            type: Boolean,
            default: false,
        },
        cover: {
            type: [Boolean, Number],
            default: false,
        },
        overlay: [Boolean, Number],
        /**
         * Manuelle Angabe, ob ein Video sichtbar ist (Wichtig für Swiper) - hierrüber kann man das
         * abspielen manuell antriggern, sofern autoplay aktiviert ist.
         */
        isVisible: {
            type: Boolean,
            default: true,
        },
        /**
         * Deaktiviert das automatische Abspielen, wenn das Video in den Viewport gelangt und autoplay
         * aktiviert ist.
         */
        viewportEvent: {
            type: Boolean,
            default: true,
        },
    },

    components: {
        // Lazy: video.js wird erst geladen, wenn ein <kuipers-video-player> tatsächlich gerendert wird.
        videoPlayer: () => import(/* webpackChunkName: "video-player" */ 'vue-video-player').then(m => m.videoPlayer),
    },

    data() {
        return {
            playerOptions: {},
            player: {},
            currentVideos: [],
            isPlaying: false,
        }
    },

    created() {
        const sources = [];

        this.currentVideos = this.videos;

        if (typeof this.currentVideos == "string") {
            this.currentVideos = [this.currentVideos];
        }

        if (this.currentVideos) {
            this.currentVideos.forEach((item) => {
                sources.push({
                    type: 'video/mp4',
                    src: item,
                });
            })
        }

        // Player-Options werden gesetzt
        this.playerOptions = {
            controls: this.controls,
            poster: this.poster,
            autoplay: this.autoplay,
            muted: this.muted,
            loop: this.loop,
            sources,
            preload: true,
        };
    },

    watch: {
        isVisible(val) {
            this.startPause(val);
        }
    },

    methods: {
        /**
         * Reagiert auf Sichtbarkeitsänderungen
         *
         * @param {boolean} isVisible
         */
        visibilityChanged(isVisible) {
            if (!this.viewportEvent) {
                return;
            }

            this.startPause(isVisible);
        },

        /**
         * Spielt oder stoppt ein Video, wenn Autoplay aktiviert ist und es (nicht) sichtbar ist
         *
         * @param {boolean} isVisible
         */
        startPause(isVisible) {
            if (typeof this.player.play !== 'function') {
                return;
            }

            if (isVisible && this.autoplay) {
                this.player.play();
            } else {
                this.player.pause();
            }
        },

        handleClick() {
            if (this.isPlaying) {
                this.player.pause();
            }
        },

        stateChanged($event) {
            this.$emit('av-on-state-changed', $event);

            if ($event.play) {
                this.isPlaying = true;
            }

            if ($event.pause) {
                this.isPlaying = false;
            }
        }
    }
});

Vue.component("av-image-carousel", {

    template: '#av-image-carousel',

    props: {
        maxQuantity:
            {
                type: Number,
                default: 10
            },
        imageUrlAccessor:
            {
                type: String,
                default: "url"
            },
        showThumbs:
            {
                type: Boolean,
                default: true
            },
        showDots:
            {
                type: Boolean,
                default: true
            },
        animationStyle:
            {
                type: String,
                default: "standard"
            },
        pluginPath:
            {
                type: String,
                default: ""
            }
    },
    inject: {
        itemId: {
            default: null
        }
    },
    data() {
        return {
            currentItem: 0
        };
    },
    computed:
        {
            currentVariation() {
                return this.$store.getters[`${this.itemId}/currentItemVariation`]
            },
            carouselImages() {
                return this.$options.filters.itemImages(
                    this.currentVariation.images,
                    "urlPreview"
                ).slice(0, this.maxQuantity);
            },
            singleImages() {
                return this.$options.filters.itemImages(
                    this.currentVariation.images,
                    this.imageUrlAccessor
                ).slice(0, this.maxQuantity);
            }
        },
    watch: {
        currentVariation:
            {
                handler(val, oldVal) {
                    if (val !== oldVal) {
                        setTimeout(() => {
                            this.reInitialize();
                        }, 1);
                    }
                },
                deep: true
            }
    },
    mounted() {
        this.$nextTick(() => {
            this.loadLightbox().then(() => {
                this.initCarousel();
                this.initThumbCarousel();
            })
                .catch(event => {
                    console.log("error while loading lightbox", event);
                });
        });
    },
    methods:
        {
            getImageCount() {
                return this.carouselImages.length > this.maxQuantity ? this.maxQuantity : this.carouselImages.length;
            },
            reInitialize() {
                const $owl = $(this.$refs.single);
                const scrollPos = document.documentElement.scrollTop;
                $owl.trigger("destroy.owl.carousel");
                $owl.html($owl.find(".owl-stage-outer").html()).removeClass("owl-loaded");
                $owl.find(".owl-item").remove();
                const $thumbs = $(this.$refs.thumbs);
                $thumbs.trigger("destroy.owl.carousel");
                $thumbs.html($thumbs.find(".owl-stage-outer").html()).removeClass("owl-loaded");
                $thumbs.find(".owl-item").remove();
                this.initCarousel();
                this.initThumbCarousel();
                // Avoid reset of scrollTop
                document.documentElement.scrollTop = scrollPos;
            },
            initCarousel() {
                const imageCount = this.getImageCount();
                const carouselSettings = {
                    autoHeight: true,
                    dots: this.showDots,
                    items: 1,
                    lazyLoad: true,
                    rewind: true,
                    margin: 10,
                    mouseDrag: imageCount > 1,
                    nav: imageCount > 1,
                    navClass: [
                        "owl-single-item-nav left carousel-control",
                        "owl-single-item-nav right carousel-control"
                    ],
                    navContainerClass: "",
                    navText: [
                        "<i class=\"owl-single-item-control fa fa-chevron-left\" aria-hidden=\"true\"></i>",
                        "<i class=\"owl-single-item-control fa fa-chevron-right\" aria-hidden=\"true\"></i>"
                    ],
                    smartSpeed: 350,
                    onChanged: event => {
                        const $thumb = $(this.$refs.thumbs);
                        $thumb.trigger("to.owl.carousel", [
                            event.page.index,
                            350
                        ]);
                    }
                };
                if (this.animationStyle !== "standard") {
                    carouselSettings.animateOut = this.animationStyle;
                }
                $(this.$refs.single).owlCarousel(carouselSettings);

                if (typeof window.lightbox !== "undefined" && window.lightbox !== null) {
                    lightbox.option({
                        wrapAround: true,
                        albumLabel: this.$translate("Ceres::Template.singleItemLightboxImageShown")
                    });
                }
                $(this.$refs.single).on("changed.owl.carousel", event => {
                    this.currentItem = event.page.index;
                });
            },
            initThumbCarousel() {
                $(this.$refs.thumbs).owlCarousel({
                    autoHeight: true,
                    dots: false,
                    items: 3,
                    lazyLoad: true,
                    loop: false,
                    margin: 10,
                    mouseDrag: false,
                    center: false,
                    nav: true,
                    navClass: [
                        "owl-single-item-nav left carousel-control",
                        "owl-single-item-nav right carousel-control"
                    ],
                    navContainerClass: "",
                    navText: [
                        "<i class=\"owl-single-item-control fa fa-chevron-left\" aria-hidden=\"true\"></i>",
                        "<i class=\"owl-single-item-control fa fa-chevron-right\" aria-hidden=\"true\"></i>"
                    ],
                    smartSpeed: 350
                });
            },
            goTo(index) {
                const $owl = $(this.$refs.single);
                $owl.trigger("to.owl.carousel", [
                    index,
                    350
                ]);
            },
            getAltText(image) {
                return image && image.alternate ? image.alternate : this.$options.filters.itemName(this.currentVariation);
            },
            getImageName(image) {
                return image && image.name ? image.name : this.$options.filters.itemName(this.currentVariation);
            },
            loadLightbox() {
                return new Promise((resolve, reject) => {
                    const script = document.querySelector("script#lightboxscript");
                    if (typeof script !== "undefined" && script !== null) {
                        resolve();
                    } else {
                        const script = document.createElement("script");
                        script.type = "text/javascript";
                        script.id = "lightboxscript";
                        script.src = `${this.pluginPath}/js/dist/lightbox.min.js`;
                        script.addEventListener("load", () => resolve(), false);
                        script.addEventListener("error", event => reject(event), false);
                        document.body.appendChild(script);
                    }
                });
            }
        }
});

Vue.component("av-goodie-list", {

    template: '#av-goodie-list',

    data() {
        return {
            basketTotalSum: 0,
            choice: {},
            alertInfo: null,
            successInfo: null,
            products: [
                {
                    name: 'Kuipers Sport- und Reisetasche schwarz',
                    value: 'tasche-schwarz',
                    minSum: 400,
                    description: '',
                    image: 'https://cdn02.plentymarkets.com/o0gc2tlefjgj/item/images/375/full/sporttasche-1.jpg'
                },
                {
                    name: 'Kuipers Sport- und Reisetasche weiß',
                    value: 'tasche-weiss',
                    minSum: 400,
                    description: '',
                    image: 'https://cdn02.plentymarkets.com/o0gc2tlefjgj/item/images/375/full/sporttasche-2.jpg'
                },
            ]
        };
    },

    computed: Vuex.mapState({
        basketItems: state => state.basket.items,
        contactWish: state => state.checkout.contactWish,
        shippingCountryId: state => state.localization.shippingCountryId,
    }),

    watch:{
        basketItems: {
            immediate: true,
            handler(newVal, oldVal) {
                this.updateSum();
            },
        },

        contactWish: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.updateContactWish();
                }
            },
        },

        choice: {
            deep: true,
            handler(newVal, oldVal) {
                this.updateContactWish();
            },
        },
    },

    methods: {
        updateSum() {
            this.basketTotalSum = 0;

            this.basketItems.forEach((item) => {
                this.basketTotalSum += (item.price * item.quantity);
            })

            if (this.basketTotalSum < 25 && this.choice.value) {
                this.choice = {};
                this.successInfo = null;
            }
        },

        getName(item) {
            let option = item.optionValue ? ' - ' + item.optionValue : '';
            return (item.value  ? '(Gratis: ' + item.name + option + ')' : '');
        },

        setGoodie(item) {
            if (!item) {
                return;
            }
            if (item.minSum > this.basketTotalSum) {
                this.alertInfo = 'Das Produkt ' + this.getName(item) + ' ist ab einem Warenwert von ' + item.minSum + '€ gratis erhältlich';

                setTimeout(() => {
                    this.alertInfo = null;
                }, 8000);

                return;
            }

            this.choice = item;

            this.successInfo =  'Das Produkt ' + this.getName(item) + ' wurde zu deiner Bestellung hinzugefügt';

        },

        updateContactWish() {
            let found = false;
            this.products.forEach((item) => {
                let data = (this.contactWish && this.contactWish !== 'null' ? this.contactWish : '').replace(this.getName(item), '');

                if (data != this.contactWish) {
                    if (this.getName(this.choice)) {
                        data += this.getName(this.choice);
                    }

                    found = true;
                    this.$store.commit("setContactWish",  data);
                }
            })

            if (!found && this.choice.value) {
                this.$store.commit("setContactWish", this.contactWish + ' ' + this.getName(this.choice));
            }
        }
    }
});

Vue.component('checkout-steps', {
    data() {
        return { currentStep: 2 };
    },
    computed: {
        billingAddressId() {
            const fromCheckout = this.$store.state.checkout && this.$store.state.checkout.billingAddressId;
            const fromAddress  = this.$store.state.address  && this.$store.state.address.billingAddressId;
            return fromCheckout || fromAddress || 0;
        }
    },
    methods: {
        nextStep() { if (this.currentStep < 3) this.currentStep++; },
        prevStep() { if (this.currentStep > 2) this.currentStep--; },
        scrollToPlaceOrder() {
            const el = document.querySelector('.basket-summary__place-order');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    },
    render(h) {
        return this.$scopedSlots.default({
            currentStep: this.currentStep,
            billingAddressId: this.billingAddressId,
            nextStep: this.nextStep.bind(this),
            prevStep: this.prevStep.bind(this),
            scrollToPlaceOrder: this.scrollToPlaceOrder.bind(this)
        });
    }
});
